import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaPagamentosInicio: [],
    buscaPagamentosSucesso: ['pagamentos'],
    buscaPagamentosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
}

// Ação para busca completa
Creators.buscaPagamentos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaPagamentosInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarPagamentos(filtro)
            .then(response => dispatch(Creators.buscaPagamentosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaPagamentosErro(error)))
    }
}

const buscaPagamentosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaPagamentosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaPagamentosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.pagamentos, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PAGAMENTOS_INICIO]: buscaPagamentosInicio,
    [Types.BUSCA_PAGAMENTOS_ERRO]: buscaPagamentosErro,
    [Types.BUSCA_PAGAMENTOS_SUCESSO]: buscaPagamentosSucesso,
})
